import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'castValue' })
export class CastValuePipe implements PipeTransform {

  transform(value: any, type: "bool" | "str" | "num"): any {
    switch (type) {
      // ↓ Convierte valores a string, aplica también para los elementos de un array
      case 'str': return [null, undefined].includes(value) ? '' : (Array.isArray(value) ? (value.map((elm: any) => `${elm}`)) : `${value}`);
      // ↓ Convierte valores a booleano, aplica también para los elementos de un array
      case 'bool': return [null, undefined].includes(value) ? 0 : (Array.isArray(value) ? (value.map((elm: any) => [true, "true"].includes(elm))) : [true, "true"].includes(value));
      // ↓ Convierte valores a número, aplica también para los elementos de un array
      case 'num': return [null, undefined].includes(value) ? 0 : (Array.isArray(value) ? (value.map((elm: any) => Number(elm))) : Number(value));
    }
  }

}
